import { getData, postData, host, proxy, createRequestHeader } from '@/assets/js/api.js'
import axios from 'axios';
import store from '@/store/index.js'
import { getQueryParams } from '@/utils/str.js'

//获得语言包
export const GetLanguagePacksList = fn => {
  let methods = '/api/Common/GetLanguagePacksList'
  getData(methods, {}, 2, fn)
}

//获得错误信息
export const GetSystemStatusList = fn => {
  let methods = '/api/Common/GetSystemStatusList'
  getData(methods, {}, 2, fn)
}

//上传图片
export const UploadFile = (params, fn, data) => {
  let methods = '/api/Upload/File'
  return postData(methods, params, 3, fn, data)
}

// 上传图片
export const UploadLightBoxPoint = (params, fn, data) => {
  let methods = '/businessapi/Design/UploadLightBoxPoint'

  return postData(methods, params, 3, fn, data)
}

//上传地图
// export const UploadMapFile = (params,fn) => {
// 	let methods = '/uploadService/upload_image';
// 	postData(methods, params, 3, fn);
// };

//获得基础数据
/**
 *获得基础数据
 * 替代接口如下
 * LanguagePacksList
 * SystemStatusList
 * EventTypeList
 * DeiveStatusList
 * DeviceTypeList
 * ProtocolTypeList
 * DeviceLogLevel
 * SystemModuleList
 * UserActionTypeList
 */
export const GetBaseData = (params = {}, fn) => {
  let methods = '/api/Common/GetBaseData'
  getData(methods, params, 2, fn)
}

// 获取对应城市的IP,域名
export const GetBaseIpRegion = (params = {}, fn) => {
  let methods = '/ipLocation/region'
  return getData(methods, params, 2, fn)
}
//查询面板设备图片
export const GetPanelKeyIcon = (params, fn) => {
  let methods = '/api/Common/GetPanelKeyIcon'
  return getData(methods, params, 1, fn)
}

export const GetStaticConfig = (params, fn) => {
  let methods = `/api/Common/GetStaticConfig/${params.type}`
  getData(methods, {}, 1, fn)
}

export const GetIsNeedOtaList = (params, fn) => {
  let methods = `/api/OTA/GetIsNeedOtaList`
  return postData(methods, params, 1, fn)
}

export const GetLoginConfig = params=> {
	let methods = `/baseservice/Common/GetLoginConfig`;

	return getData(methods, params, 2);
};

let pendingAITokenRequest = null;
const AI_TOKEN_EXPIRE_BUFFER_MS = 60 * 1000;

function resolveUserToken(explicitToken) {
  if (explicitToken) return explicitToken;
  if (store.state.token) return store.state.token;

  try {
    const query = getQueryParams(window.location.href);
    if (query.token) return query.token;
  } catch (e) { }

  return '';
}

// OAuth2.0：用当前用户 token 换取 AI 接口所需的 ai-token
// 本项目进入 /ai-paint、第三方跳转进入时都会走这里
export const GetAIToken = async (userToken) => {
  const { aiToken, aiTokenExpireTime } = store.state;

  if (aiToken && aiTokenExpireTime && Date.now() < aiTokenExpireTime - AI_TOKEN_EXPIRE_BUFFER_MS) {
    return { access_token: aiToken };
  }

  if (pendingAITokenRequest) {
    return pendingAITokenRequest;
  }

  pendingAITokenRequest = (async () => {
    const sourceToken = resolveUserToken(userToken);
    if (!sourceToken) {
      return {};
    }

    const params = new URLSearchParams({
      grant_type: 'user_to_ai_token',
      user_token: sourceToken,
      client_id: 'opple_web_ai',
    });

    const url = host + proxy + (store.state.apibase || '') + '/auth2/token';
    const headers = {
      ...createRequestHeader(2),
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    const res = await axios.post(url, params, {
      timeout: 60000,
      headers,
    });

    const data = res.data;
    if (data?.access_token) {
      store.commit('setAIToken', {
        access_token: data.access_token,
        expires_in: data.expires_in,
      });
    }

    return data || {};
  })();

  try {
    return await pendingAITokenRequest;
  } finally {
    pendingAITokenRequest = null;
  }
};

